type TSpinnerProps = {
  text?: string;
};

export default function Spinner({ text }: TSpinnerProps) {
  return (
    <div className={"flex h-full w-full flex-col items-center justify-center"}>
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-primary ease-in-out" />
      {text && <div className="mt-4">{text}</div>}
    </div>
  );
}
